import React, { useRef } from 'react';

interface FaqAccordionItemProps {
	title: string;
	value: string;
	isOpen: boolean;
	onClick: () => any;
}

const FaqAccordionItemComponent = (props: FaqAccordionItemProps) => {
	const contentHeight = useRef<HTMLDivElement | null>(null)
	
	return (
		<div className="faqAccordionItem">
			<button className={`faqAccordionItem__title ${props.isOpen ? 'active' : ''}`} onClick={props.onClick}>
				<div className="faqAccordionItem__title_text">
					<h4>{props.title}</h4>
					<svg
						className={`faqAccordionItem__title_text_arrow ${props.isOpen ? 'active' : ''}`}
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="25"
						viewBox="0 0 24 25"
						fill="none"
					>
						<path d="M5.29289 9.57024C5.68342 9.17971 6.31658 9.17971 6.70711 9.57024L12 14.8631L17.2929 9.57024C17.6834 9.17971 18.3166 9.17971 18.7071 9.57024C19.0976 9.96076 19.0976 10.5939 18.7071 10.9845L12.7071 16.9845C12.3166 17.375 11.6834 17.375 11.2929 16.9845L5.29289 10.9845C4.90237 10.5939 4.90237 9.96076 5.29289 9.57024Z" fill="white"/>
					</svg>
				</div>
			</button>
			
			<div
				ref={contentHeight}
				className={`faqAccordionItem__value ${props.isOpen && 'opened'}`}
				style={
					props.isOpen && contentHeight && contentHeight.current && contentHeight.current.scrollHeight
						? { height: contentHeight.current.scrollHeight + 24 }
						: { height: "0px" }
				}
				onClick={props.onClick}
			>
				<p dangerouslySetInnerHTML={{ __html: props.value }} />
			</div>
		</div>
	);
};

export default FaqAccordionItemComponent;